import React, { useState } from 'react';
import styles from './SelectionTypeAccount.module.scss';
import logo from '../../assets/images/Logo-bodhiwell.png';
import useSelectionTypeAccount from '../../hooks/useSelectionTypeAccount';
import { Link } from 'react-router-dom';
import { ButtonUi } from '../../components/ui/ButtonUi/ButtonUi';

const SelectionTypeAccount: React.FC = () => {
    const { handleUpdateProfile, loading, error, t, user } = useSelectionTypeAccount();
    const [selectedType, setSelectedType] = useState<'professional' | 'patient' | null>(null);

    const handleContinue = () => {
        if (selectedType) {
            handleUpdateProfile(selectedType);
        }
    };

    return (
        <div className={styles['selection-account']}>
            <div className={styles['selection-account__wrapper']}>
                
                <header className={styles['selection-account__header']}>
                    <Link to="/">
                        <img src={logo} alt="bodhiWell" className={styles['selection-account__logo']} />
                    </Link>
                </header>

                <main className={styles['selection-account__card']}>
                    <h2 
                        className={styles['selection-account__title']} 
                        dangerouslySetInnerHTML={{ __html: t('landing.SelectionTypeAccount.welcomeTitle') }}
                    ></h2>
                    <p className={styles['selection-account__intro']}>
                        {t('landing.SelectionTypeAccount.platformQuestion')}
                    </p>

                    {user?.uid && (
                        <div className={styles['selection-account__google-account']}>
                            <span className={styles['gmark']}>G</span>
                            <span>
                                {t('landing.SelectionTypeAccount.loggedInWithGoogle', 'Ingresaste con Google como:')}{' '}
                                <strong>{user?.email}</strong>
                            </span>
                        </div>
                    )}

                    <div className={styles['selection-account__options']} role="radiogroup" aria-label="Elegí cómo querés usar Bodhiwell">
                        <button
                            className={`${styles['selection-account__option']} ${selectedType === 'professional' ? styles['selection-account__option--selected'] : ''}`}
                            type="button"
                            role="radio"
                            aria-checked={selectedType === 'professional'}
                            onClick={() => setSelectedType('professional')}
                            disabled={loading}
                        >
                            <h3>{t('landing.SelectionTypeAccount.healthProfessional')}</h3>
                            <p>{t('landing.SelectionTypeAccount.healthProfessionalDescription', 'Quiero ofrecer mis servicios y gestionar mi agenda.')}</p>
                            <span className={styles['selection-account__indicator']} aria-hidden="true">✓</span>
                        </button>
                        
                        <button
                            className={`${styles['selection-account__option']} ${selectedType === 'patient' ? styles['selection-account__option--selected'] : ''}`}
                            type="button"
                            role="radio"
                            aria-checked={selectedType === 'patient'}
                            onClick={() => setSelectedType('patient')}
                            disabled={loading}
                        >
                            <h3>{t('landing.SelectionTypeAccount.improveWellness')}</h3>
                            <p>{t('landing.SelectionTypeAccount.improveWellnessDescription', 'Busco profesionales y quiero gestionar mis consultas.')}</p>
                            <span className={styles['selection-account__indicator']} aria-hidden="true">✓</span>
                        </button>
                    </div>

                    <div className={styles['selection-account__actions']}>
                        <ButtonUi 
                            variant="contained" 
                            onClick={handleContinue}
                            disabled={loading || !selectedType}
                            className={styles['selection-account__submit-btn']}
                        >
                            {loading ? t('landing.SelectionTypeAccount.processing', 'Procesando...') : t('landing.SelectionTypeAccount.continue', 'Continuar')}
                        </ButtonUi>
                    </div>

                    <Link to="/" className={styles['selection-account__tertiary-link']}>
                        {t('landing.SelectionTypeAccount.goHome', 'Ir al inicio')}
                    </Link>

                    {error && (
                        <div className={styles['selection-account__error']}>
                            {error}
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default SelectionTypeAccount;